module.exports = __webpack_public_path__ + "img/courses-banner.556495de.jpg";